/** @format */

import React from "react";
import {
  HeroGrid,
  DesktopTextHolder,
  HeroText,
  OuterSpan,
  InnerSpan,
} from "../Common";

import {
  PROVIDING,
  ACCURATE,
  AND,
  TRUSTED,
  STATS,
  TO,
  THE,
  PUBLIC,
  STAGGER_PARENT,
} from "../../animation";
import styled from "styled-components";
import { QUERIES } from "../../constants";

export default function Hero({ mouseEnter, mouseLeave }) {
  return (
    <HeroWrapper>
      <HeroGrid>
        <DesktopTextHolderWrapper>
          <HeroText variants={STAGGER_PARENT} initial="hidden" animate="show">
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={PROVIDING}
                initial="hidden"
                animate="show"
              >
                Providing
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={ACCURATE}
                initial="hidden"
                animate="show"
              >
                Accurate
              </InnerSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={AND}
                initial="hidden"
                animate="show"
              >
                And
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={TRUSTED}
                initial="hidden"
                animate="show"
              >
                Trusted
              </InnerSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={STATS}
                initial="hidden"
                animate="show"
              >
                Stats
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={TO}
                initial="hidden"
                animate="show"
              >
                To
              </InnerSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={THE}
                initial="hidden"
                animate="show"
              >
                The
              </InnerSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={PUBLIC}
                initial="hidden"
                animate="show"
              >
                Public
              </InnerSpan>
            </OuterSpan>
          </HeroText>
        </DesktopTextHolderWrapper>
        <MobileTextHolder>
          <HeroText>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={PROVIDING}
                initial="hidden"
                animate="show"
              >
                Providing
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={ACCURATE}
                initial="hidden"
                animate="show"
              >
                Accurate
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={AND}
                initial="hidden"
                animate="show"
              >
                And
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={TRUSTED}
                initial="hidden"
                animate="show"
              >
                Trusted
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={STATS}
                initial="hidden"
                animate="show"
              >
                Stats
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={TO}
                initial="hidden"
                animate="show"
              >
                To
              </InnerSpan>
            </OuterSpan>
            <OuterSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={THE}
                initial="hidden"
                animate="show"
              >
                The
              </InnerSpan>
              <InnerSpan
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={PUBLIC}
                initial="hidden"
                animate="show"
              >
                Public
              </InnerSpan>
            </OuterSpan>
          </HeroText>
        </MobileTextHolder>
      </HeroGrid>
    </HeroWrapper>
  );
}

const HeroWrapper = styled.div``;

const DesktopTextHolderWrapper = styled(DesktopTextHolder)`
  @media ${QUERIES.phoneAndSmaller} {
    grid-column: 2 / -1;
    display: none;
  }
`;

const MobileTextHolder = styled(DesktopTextHolder)`
  display: none;
  font-size: 60px;

  @media ${QUERIES.phoneAndSmaller} {
    padding-top: 5vh;
    display: initial;
  }
`;
